export const TotalRows = ({ total }) => {
  return (
    <div style={{ margin: '10px 0 0 10px', textAlign: 'left', fontSize: '0.875rem' }}>
      Total rows: {total}
    </div>
  );
};
